export function isMobile(): boolean {
  if (/Mobi|Android/i.test(navigator.userAgent)) {
    return true;
  }
  return false;
}

// web api를 사용해서 web util에 둠
export const krwCurrencyFormatter = (price: number) => {
  const formatter = new Intl.NumberFormat('ko-KR');
  return isNaN(price) ? undefined : formatter.format(price);
};

/**
 * @returns opener 와 origin 이 같으면 true, opener 가 없거나 origin 이 다르면 false
 */
export function checkOpenerSameOrigin() {
  if (window.opener === null) {
    return false;
  }
  try {
    window.opener.origin;
  } catch (err) {
    const error = err as Error;
    if (error.name === 'SecurityError') {
      return false;
    }
    throw error;
  }
  return true;
}

export const isIos = () =>
  typeof navigator !== 'undefined' &&
  /iPad|iPhone|iPod/.test(navigator.userAgent);
